import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Users, Activity, UserCheck, UserX, Target } from 'lucide-react';

const DashboardStats = ({ stats, onShowShifts }) => (
    <>
        {/* Main Stats Grid - Evacuation */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <Card className="stat-card border-l-red-500" data-testid="stat-to-evacuate">
                <CardContent className="p-0">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="stat-value text-blue-400">{stats?.persons_heberges || 0}</p>
                            <p className="stat-label">Heberges en centre</p>
                        </div>
                        <UserX className="w-8 h-8 text-red-500/50" />
                    </div>
                </CardContent>
            </Card>

            <Card className="stat-card border-l-amber-500" data-testid="stat-evacuating">
                <CardContent className="p-0">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="stat-value text-amber-500">{stats?.persons_evacuating || 0}</p>
                            <p className="stat-label">En cours d'évacuation</p>
                        </div>
                        <Activity className="w-8 h-8 text-amber-500/50" />
                    </div>
                </CardContent>
            </Card>

            <Card className="stat-card border-l-green-500" data-testid="stat-evacuated">
                <CardContent className="p-0">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="stat-value text-green-500">{stats?.persons_evacuated || 0}</p>
                            <p className="stat-label">Évacuées</p>
                        </div>
                        <UserCheck className="w-8 h-8 text-green-500/50" />
                    </div>
                </CardContent>
            </Card>

            <Card className="stat-card border-l-blue-500" data-testid="stat-prises-en-charge">
                <CardContent className="p-0">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="stat-value text-blue-500">{stats?.persons_prises_en_charge || 0}</p>
                            <p className="stat-label">Pris en charge</p>
                        </div>
                        <Users className="w-8 h-8 text-blue-500/50" />
                    </div>
                    <p className="text-[10px] text-zinc-500 mt-1">Fiche bilan renseignée</p>
                </CardContent>
            </Card>
        </div>

        {/* Secondary Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
            <Card className="stat-card border-l-purple-500" data-testid="stat-incidents">
                <CardContent className="p-0">
                    <p className="stat-value">{stats?.active_incidents || 0}</p>
                    <p className="stat-label">Incidents actifs</p>
                </CardContent>
            </Card>

            <Card className="stat-card border-l-cyan-500" data-testid="stat-care-centers">
                <CardContent className="p-0">
                    <p className="stat-value">{stats?.open_care_centers || 0}</p>
                    <p className="stat-label">CARE ouverts</p>
                </CardContent>
            </Card>

            <Card className="stat-card border-l-pink-500" data-testid="stat-resources">
                <CardContent className="p-0">
                    <p className="stat-value font-mono">{stats?.resources_available || 0}/{stats?.total_resources || 0}</p>
                    <p className="stat-label">Ressources dispo.</p>
                </CardContent>
            </Card>

            <Card className="stat-card border-l-orange-500" data-testid="stat-vehicles">
                <CardContent className="p-0">
                    <p className="stat-value">{stats?.vehicles_on_mission || 0}/{stats?.total_vehicles || 0}</p>
                    <p className="stat-label">Vehicules en mission</p>
                </CardContent>
            </Card>

            <Card className="stat-card border-l-teal-500 cursor-pointer hover:border-teal-400/50 transition-colors" data-testid="stat-shifts" onClick={onShowShifts}>
                <CardContent className="p-0">
                    <p className="stat-value">{stats?.active_personnel || 0}</p>
                    <p className="stat-label">Personnel actif</p>
                </CardContent>
            </Card>

            <Card className="stat-card border-l-blue-500" data-testid="stat-missions">
                <CardContent className="p-0">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="stat-value text-blue-400">{stats?.active_missions || 0}</p>
                            <p className="stat-label">Missions actives</p>
                        </div>
                        <Target className="w-6 h-6 text-blue-500/50" />
                    </div>
                </CardContent>
            </Card>
        </div>
    </>
);

export default DashboardStats;
